import { render, staticRenderFns } from "./PurimNewPayment.vue?vue&type=template&id=393b2a0c&"
import script from "./PurimNewPayment.vue?vue&type=script&lang=js&"
export * from "./PurimNewPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports